module.exports = __webpack_public_path__ + "img/tewi inaba_lw.68d96d92.png";